/**
 * Created by neo on 16.08.23
 */
import { makeAutoObservable } from 'mobx';

export type OnlineMeetingEntryEmbedDataEntryJson = {
  videoEmbedCode?: string;
  interactionEmbedCode?: string;
};

export type OnlineMeetingEntryEmbedDataEntry = OnlineMeetingEntryEmbedDataEntryJson & {
  toJS(): OnlineMeetingEntryEmbedDataEntryJson;
};

export function createOnlineMeetingEntryEmbedDataEntry(json?: Partial<OnlineMeetingEntryEmbedDataEntryJson>): OnlineMeetingEntryEmbedDataEntry {
  return makeAutoObservable({
    videoEmbedCode: json?.videoEmbedCode,
    interactionEmbedCode: json?.interactionEmbedCode,

    toJS(): OnlineMeetingEntryEmbedDataEntryJson {
      return {
        videoEmbedCode: this.videoEmbedCode,
        interactionEmbedCode: this.interactionEmbedCode,
      };
    },
  });
}
